import { i18n_config_default } from './chunk-5FPUWZMY.mjs';

// src/helpers/menu/buckets/itemGroups.ts
var getItemInactiveMenuTypeVersionsText = (menuTypeVersions) => {
  const text = "";
  const numberOfInactiveMenuTypeVersions = Object.values(
    menuTypeVersions
  ).filter((menuTypeVersion) => !menuTypeVersion.active).length;
  return numberOfInactiveMenuTypeVersions > 0 ? `${i18n_config_default.t("commonTexts.inactive")} (${numberOfInactiveMenuTypeVersions} ${i18n_config_default.t("menuScreen.common.bucket.menuTypes.plural")})` : text;
};

export { getItemInactiveMenuTypeVersionsText };
